import React, { useEffect, useState } from 'react';
import { adminApi } from '../../api/client';
import Modal from '../../components/common/Modal';
import Spinner from '../../components/common/Spinner';
import { FaPlus, FaSearch } from 'react-icons/fa';
import toast from 'react-hot-toast';

export default function Learners() {
  const [learners, setLearners] = useState([]);
  const [grades,   setGrades]   = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [modal,    setModal]    = useState(false);
  const [search,   setSearch]   = useState('');
  const [gradeFilter, setGradeFilter] = useState('');
  const [form, setForm] = useState({
    first_name:'', surname:'', email:'', phone:'', grade_id:'',
    dob:'', id_number:'', address:'', gender:'',
    parent_name:'', parent_email:'', parent_phone:'',
  });

  const load = () => {
    Promise.all([adminApi.getLearners({ search, grade_id: gradeFilter }), adminApi.getGrades()])
      .then(([l, g]) => { setLearners(l.data.data); setGrades(g.data.data); })
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, [search, gradeFilter]); // eslint-disable-line

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const res = await adminApi.addLearner(form);
      const tmpPass = res.data.data?.temp_password;
      toast.success(`Learner added!${tmpPass ? ` Temp password: ${tmpPass}` : ''}`);
      setModal(false); load();
    } catch (err) { toast.error(err.response?.data?.message || 'Failed'); }
  };

  const f = (label, key, type='text', req=false, opts=null, hint=null) => (
    <div style={{ marginBottom: 12 }}>
      <label className="sms-label">
        {label}
        {req && <span style={{ color:'#ef4444' }}>*</span>}
        {!req && <span style={{ color:'#9ca3af', fontWeight:400, fontSize:'0.75rem' }}> (optional)</span>}
      </label>
      {hint && <div style={{ fontSize:'0.75rem', color:'#6b7280', marginBottom:4 }}>{hint}</div>}
      {opts
        ? <select className="sms-input" value={form[key]} onChange={e => setForm({ ...form, [key]: e.target.value })} required={req}>
            <option value="">Select...</option>
            {opts.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
          </select>
        : <input className="sms-input" type={type} value={form[key]} onChange={e => setForm({ ...form, [key]: e.target.value })} required={req} />
      }
    </div>
  );

  return (
    <div>
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div><h2>Learners</h2><p>{learners.length} learners enrolled</p></div>
        <button className="sms-btn sms-btn-primary" onClick={() => { setForm({ first_name:'',surname:'',email:'',phone:'',grade_id:'',dob:'',id_number:'',address:'',gender:'',parent_name:'',parent_email:'',parent_phone:'' }); setModal(true); }}>
          <FaPlus size={13} /> Add Learner
        </button>
      </div>

      <div style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
        <div style={{ position: 'relative', flex: 1, maxWidth: 360 }}>
          <FaSearch style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: '#9ca3af' }} />
          <input className="sms-input" style={{ paddingLeft: 36 }} placeholder="Search learners..." value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <select className="sms-input" style={{ width: 180 }} value={gradeFilter} onChange={e => setGradeFilter(e.target.value)}>
          <option value="">All Grades</option>
          {grades.map(g => <option key={g.grade_id} value={g.grade_id}>Grade {g.grade_number}</option>)}
        </select>
      </div>

      <div className="sms-card" style={{ padding: 0, overflow: 'hidden' }}>
        {loading ? <Spinner /> : (
          <table className="sms-table">
            <thead><tr><th>Name</th><th>Email</th><th>Grade</th><th>Gender</th><th>Status</th></tr></thead>
            <tbody>
              {learners.map(l => (
                <tr key={l.user_id}>
                  <td style={{ fontWeight: 500 }}>{l.first_name} {l.surname}</td>
                  <td style={{ color: '#6b7280', fontSize: '0.85rem' }}>{l.email}</td>
                  <td>Grade {l.grade_number || '—'}</td>
                  <td style={{ textTransform: 'capitalize' }}>{l.gender || '—'}</td>
                  <td><span className={`sms-badge ${l.status === 'active' ? 'badge-present' : 'badge-absent'}`}>{l.status}</span></td>
                </tr>
              ))}
              {learners.length === 0 && <tr><td colSpan="5" style={{ textAlign: 'center', color: '#9ca3af', padding: '40px 0' }}>No learners found</td></tr>}
            </tbody>
          </table>
        )}
      </div>

      <Modal show={modal} onClose={() => setModal(false)} title="Add Learner" size="lg">
        <form onSubmit={handleSave}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            {f('First Name','first_name','text',true)}
            {f('Surname','surname','text',true)}
            {f('Email Address','email','email',false,null,'If provided, learner gets their own login to view marks, timetable & materials')}
            {f('Phone','phone')}
            {f('Grade','grade_id','text',true, grades.map(g=>({v:g.grade_id,l:`Grade ${g.grade_number}`})))}
            {f('Gender','gender','text',false,[{v:'male',l:'Male'},{v:'female',l:'Female'},{v:'other',l:'Other'}])}
            {f('Date of Birth','dob','date')}
            {f('ID Number','id_number')}
            {f('Address','address')}
          </div>

          {/* Notice about email */}
          <div style={{ background:'#eff6ff', border:'1px solid #bfdbfe', borderRadius:8, padding:'10px 14px', margin:'8px 0 4px', fontSize:'0.82rem', color:'#1e40af' }}>
            📧 <strong>Learner email is optional.</strong> For young learners (primary school), leave blank — only the parent portal is needed. For older learners (high school), add their email so they can log in independently to view marks, timetable and materials.
            <div style={{ marginTop:4, color:'#3b82f6' }}>⚠️ Learner email must be <strong>different</strong> from parent email.</div>
          </div>

          <div style={{ margin: '16px 0 8px', fontWeight: 600, color: '#374151', borderTop: '1px solid #e5e7eb', paddingTop: 14 }}>
            Parent / Guardian
          </div>
          <div style={{ background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:8, padding:'10px 14px', marginBottom:10, fontSize:'0.82rem', color:'#065f46' }}>
            👨‍👩‍👧 <strong>Parent account rules:</strong>
            <ul style={{ margin:'4px 0 0 16px', padding:0 }}>
              <li>New parent email → new account created, password emailed to them</li>
              <li>Existing parent email → learner linked to existing account (no new password sent)</li>
              <li>Same parent account works across multiple schools</li>
            </ul>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            {f('Parent Name','parent_name')}
            {f('Parent Email','parent_email','email',false,null,'Parent will receive login credentials to monitor this learner')}
            {f('Parent Phone','parent_phone')}
          </div>
          <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
            <button type="submit" className="sms-btn sms-btn-primary">Add Learner</button>
            <button type="button" className="sms-btn sms-btn-outline" onClick={() => setModal(false)}>Cancel</button>
          </div>
        </form>
      </Modal>
    </div>
  );
}
